"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var columns_1 = require("../../DataGrid/context/columns");
var TableCell_1 = __importDefault(require("./TableCell"));
var getRowKey = function (value) { return value; };
var TableBody = function (_a) {
    var data = _a.data;
    var columnsState = (0, columns_1.useColumnsContext)().columnsState;
    return (react_1.default.createElement(TableBody_1.default, null, data.map(function (row, rowIndex) { return (react_1.default.createElement(TableRow_1.default, { key: getRowKey(rowIndex) }, columnsState.map(function (column) { return (react_1.default.createElement(TableCell_1.default, { key: column.id, row: row, column: column, rowIndex: rowIndex })); }))); })));
};
exports.default = TableBody;
